import * as Redux from 'redux';
import { IActionCreator } from '../../../../common/interfaces/IActionCreator';
import { Keys } from './types';
import { invokeApi } from '../../../../common/networking/invoker';
import { ActivitySchedule, ActivityDefinition } from '../../../../model/activities';
import { push } from 'react-router-redux';
import { contact } from '../../../../model/contact';

export interface IActions {
    saveNewActivity: (definition: ActivityDefinition, schedules: ActivitySchedule[]) => any;
    loadActivities: () => any;
    delete: (id: string) => any;
    save: (a: ActivityDefinition) => any;
    confirm: (id: string) => any;
    navigateTo: (path: string) => void;
    selectActivity: (id: string) => void;
    updateActivity: (activity: ActivityDefinition) => void;
    saveSchedule: (activity: ActivitySchedule, updateSimilar: boolean) => void;
    saveSchedules: (activity: ActivitySchedule[]) => void;
    deleteSchedule: (id: string) => void;
    createSchedule: (s: ActivitySchedule) => void;
    deleteSchedules: (id: string[]) => void;
    createSchedules: (s: ActivitySchedule[]) => void;
    addReservation:(contact:contact, schedule:ActivitySchedule)=>any;
    removeReservation:(scheduleId:string, id:string)=>any;
}


export const actionCreator: IActionCreator<IActions> = (dispatch: Redux.Dispatch<any>): IActions => {
    return {
        navigateTo: path => dispatch(push(path)),
        addReservation:(c, s)=>{
            const path = `/api/Activities/Schedules/${s._id}/reservations`;
            return dispatch({
                type: Keys.ADDRESERVATION,
                payload: invokeApi({
                    path: path,
                    body:c.sub,
                    method: 'POST',
                    responseType: 'json'
                })
            })
        },
        removeReservation:(scheduleId:string, id:string)=>{
            const path = `/api/Activities/Schedules/${scheduleId}/reservations/${id}`;
            return dispatch({
                type: Keys.REMOVERESERVATION,
                payload: invokeApi({
                    path: path,
                    method: 'DELETE',
                    responseType: 'json'
                })
            })
        },
        updateActivity: (activity: ActivityDefinition) => {
            dispatch({
                type: Keys.UPDATEACTIVITY,
                payload: activity
            })
        },
        saveSchedule: (s: ActivitySchedule, updateSimilar: boolean = false) => {
            console.log("saveSchedule Activities", s, updateSimilar);
            dispatch({
                type: Keys.SAVESCHEDULE,
                payload: invokeApi({
                    path: '/api/Activities/Schedules/' + s._id + (updateSimilar ? '/updateallsimilar' : ''),
                    method: 'PUT',
                    body: s,
                    responseType: 'json'
                })
            })
        },
        saveSchedules: (s: ActivitySchedule[]) => {
            dispatch({
                type: Keys.SAVESCHEDULE,
                payload: invokeApi({
                    path: '/api/Activities/Schedules',
                    method: 'PUT',
                    body: s,
                    responseType: 'json'
                })
            })
        },
        createSchedule: (s: ActivitySchedule) => {
            dispatch({
                type: Keys.CREATESCHEDULE,
                payload: invokeApi({
                    path: '/api/Activities/Schedules',
                    method: 'POST',
                    body: s,
                    responseType: 'json'
                })
            })
        },
        deleteSchedule: (id: string) => {
            dispatch({
                type: Keys.DELETESCHEDULE,
                payload: invokeApi({
                    path: '/api/Activities/Schedules/' + id,
                    method: 'DELETE',
                }),
                meta: id
            })
        },
        createSchedules: (s: ActivitySchedule[]) => {
            dispatch({
                type: Keys.CREATESCHEDULES,
                payload: invokeApi({
                    path: '/api/Activities/Schedules/creations',
                    method: 'POST',
                    body: s,
                    responseType: 'json'
                })
            })
        },
        deleteSchedules: (ids: string[]) => {
            dispatch({
                type: Keys.DELETESCHEDULES,
                payload: invokeApi({
                    path: '/api/Activities/Schedules/deletions',
                    method: 'POST',
                    body:ids
                }),
                meta: ids
            })
        },
        save: (a: ActivityDefinition) => {
            dispatch({
                type: Keys.SAVEACTIVITY,
                payload: invokeApi({
                    path: '/api/Activities/' + a._id,
                    method: 'PUT',
                    body: a,
                    responseType: 'json'
                })
            })
        },
        selectActivity: (id: string) => {

            dispatch({
                type: Keys.SELECTACTIVITY,
                payload: invokeApi({
                    path: '/api/Activities/' + id,
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
        delete: (id: string) => {
            dispatch({
                type: Keys.DELETEACTIVITY,
                payload: invokeApi({
                    path: '/api/Activities/' + id,
                    method: 'DELETE'
                }),
                meta: id
            })
        },
        confirm: (id: string) => {

        },
        saveNewActivity: (definition: ActivityDefinition, schedules: ActivitySchedule[]) => {
            return dispatch({
                type: Keys.SAVENEWACTIVITY,
                payload: invokeApi({
                    body: {
                        activityDefinition: definition,
                        schedules: schedules
                    },
                    path: '/api/Activities',
                    method: 'POST',
                    responseType: 'json'
                })
            })
        },
        loadActivities: () => {
            dispatch({
                type: Keys.LOADACTIVITIES,
                payload: invokeApi({
                    path: '/api/Activities',
                    method: 'GET',
                    responseType: 'json'
                })
            })
        },
    }
}